"use strict";
exports.__esModule = true;
exports.PieceBuilder = exports.Piece = exports.PieceReferenceBuilder = exports.PieceReference = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var PieceModel_1 = require("./PieceModel");
var PieceReference = /** @class */ (function () {
    function PieceReference() {
    }
    PieceReference.identical = function (c1, c2) {
        return (c1.pieceId === c2.pieceId && c1.pieceModelId === c2.pieceModelId && PieceModel_1.PieceConfiguration.identical(c1.pieceConfiguration, c2.pieceConfiguration));
    };
    return PieceReference;
}());
exports.PieceReference = PieceReference;
var PieceReferenceBuilder = /** @class */ (function () {
    function PieceReferenceBuilder(reference) {
        this.reference = reference;
    }
    PieceReferenceBuilder.initialise = function (pieceId, pieceModelId, pieceConfiguration) {
        return new PieceReferenceBuilder({
            pieceId: pieceId,
            pieceModelId: pieceModelId,
            pieceConfiguration: pieceConfiguration
        });
    };
    PieceReferenceBuilder.prototype.build = function () {
        return this.reference;
    };
    return PieceReferenceBuilder;
}());
exports.PieceReferenceBuilder = PieceReferenceBuilder;
var Piece = /** @class */ (function () {
    function Piece() {
    }
    Piece.isPublishable = function (piece) {
        if (piece.models.length === 0)
            return false;
        for (var _i = 0, _a = piece.models; _i < _a.length; _i++) {
            var pieceModel = _a[_i];
            if (!PieceModel_1.PieceModel.isPublishable(pieceModel))
                return false;
        }
        return true;
    };
    Piece.getAllAvailablePieceConfigurationsFromMultiplePieces = function (pieces) {
        var results = [];
        for (var _i = 0, pieces_1 = pieces; _i < pieces_1.length; _i++) {
            var piece = pieces_1[_i];
            var _loop_1 = function (pieceConfig) {
                if (!results.find(function (pc) { return PieceModel_1.PieceConfiguration.identical(pc, pieceConfig); })) {
                    results.push(pieceConfig);
                }
            };
            for (var _a = 0, _b = Piece.getAllAvailablePieceConfigurations(piece); _a < _b.length; _a++) {
                var pieceConfig = _b[_a];
                _loop_1(pieceConfig);
            }
        }
        return results;
    };
    Piece.getAllAvailablePieceConfigurations = function (piece) {
        if (piece.models.length === 0) {
            return [];
        }
        return piece.models.map(function (m) { return m.availableConfigurations; }).reduce(function (c1, c2) { return c1.concat(c2); });
    };
    Piece.getAllPieceWeights = function (piece) {
        if (piece.models.length === 0) {
            return [];
        }
        return piece.models.map(function (m) { return m.weights; }).reduce(function (c1, c2) { return c1.concat(c2); });
    };
    Piece.getAllPieceImages = function (piece) {
        if (piece.models.length === 0) {
            return [];
        }
        return piece.models.map(function (m) { return m.images; }).reduce(function (c1, c2) { return c1.concat(c2); });
    };
    return Piece;
}());
exports.Piece = Piece;
var PieceBuilder = /** @class */ (function () {
    function PieceBuilder(piece) {
        this.piece = piece;
    }
    PieceBuilder.initialiseWithPiece = function (piece) {
        return new PieceBuilder(piece);
    };
    PieceBuilder.initialise = function (title, description, geometryType) {
        return PieceBuilder.initialiseWithPiece({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            title: title,
            description: description,
            geometryType: geometryType,
            models: []
        });
    };
    PieceBuilder.prototype.createOrReplacePieceModel = function (newPieceModel) {
        if (this.hasPieceModelWithId(newPieceModel.id) || this.hasPieceModelWithSizeAndStones(newPieceModel.sizeType, newPieceModel.stonesPlacementType)) {
            return this.deletePieceModel(newPieceModel.id).createPieceModel(newPieceModel);
        }
        else {
            return this.createPieceModel(newPieceModel);
        }
    };
    PieceBuilder.prototype.hasPieceModelWithId = function (pieceModelId) {
        return (this.piece.models.find(function (model) { return model.id === pieceModelId; }) !== undefined);
    };
    PieceBuilder.prototype.hasPieceModelWithSizeAndStones = function (sizeType, stonesPlacementType) {
        return (this.piece.models.find(function (model) { return (model.sizeType === sizeType) && (model.stonesPlacementType === stonesPlacementType); }) !== undefined);
    };
    PieceBuilder.prototype.createPieceModel = function (newPieceModel) {
        if (this.hasPieceModelWithId(newPieceModel.id))
            throw new core_common_domain_1.Exception("Cannot update the piece to add model with id " + newPieceModel.id + " because a model with the same id already exists");
        if (this.hasPieceModelWithSizeAndStones(newPieceModel.sizeType, newPieceModel.stonesPlacementType))
            throw new core_common_domain_1.Exception("Cannot update the piece to add model " + JSON.stringify(newPieceModel) + " because a model with the same sizeType & stonesPlacementType already exists");
        this.piece.models.push(newPieceModel);
        return this;
    };
    PieceBuilder.prototype.deletePieceModel = function (pieceModelId) {
        if (!this.hasPieceModelWithId(pieceModelId))
            throw new core_common_domain_1.Exception("Cannot update the piece to remove model with id " + pieceModelId + " because it cannot be found inside the piece " + this.getId());
        this.piece.models = this.piece.models.filter(function (model) { return model.id !== pieceModelId; });
        return this;
    };
    PieceBuilder.prototype.removeAllPieceModels = function () {
        this.piece.models = [];
        return this;
    };
    PieceBuilder.prototype.withId = function (id) {
        this.piece.id = id;
        return this;
    };
    PieceBuilder.prototype.getId = function () {
        return this.piece.id;
    };
    PieceBuilder.prototype.build = function () {
        return this.piece;
    };
    PieceBuilder.prototype.buildUpdate = function () {
        return {
            title: this.piece.title,
            description: this.piece.description,
            geometryType: this.piece.geometryType,
            models: this.piece.models
        };
    };
    return PieceBuilder;
}());
exports.PieceBuilder = PieceBuilder;
